
const BikesDetails =[

    { 
         name : " Ducati 1098s",
         description :"The Ducati 1098 is well-known fastest heavy bike. Ducati Production is its owner. It is a motorbikes manufacturers and headquarter is present in Italy.",
        pic:require("./images/Ducati-1098S.jpg"),
        },
    
    {
         name : "BMW K 1200S",
         description :"A great sport motorcycle, BMW K 1200 S is containing liquid-cooled four-cylinder engine with power of 164 horsepower at 10250 speeds of rpm.",
        pic:require("./images/BMW-K-1200-S.jpg")
    },

    {
         name : "Aprilia RSV",
         description :"It is a heavy bike produced by Aprilia. RSV 1000R is best model up till now offered by Aprilia.  Engine is of 998 cc with 141.3 horsepower at 8000rpm.",
        pic:require("./images/Aprilia-RSV-1000R-Mille.jpg")
    },
 
    
    {
         name : "Kawasaki Ninja ZX14R",
         description :"Kawasaki Ninja ZX-14R is stylish bike manufactured by Kawasaki in Japan. This bike is very fast to ride with 10500 rpm.",
        pic:require("./images/Kawasaki-Ninja-ZX-14R.jpg")
    },

    
    {
        name : "Agusta F4",
        description :"Another motorbike manufactured in Italy, MV Agusta F4 1000 R offers wonderful features like rare shock absorber which make it to adjust easily either in low and high speed.",
       pic:require("./images/MV-Agusta-F4-1000-R.jpg")
   },

   
   {
    name : "Yamaha YZFR1 ",
    description :"The Yamaha motorbike is redesign of the engine  appears as Yamaha YZF R1.  This bike having additional characters established like its Handling ability increased up to certain extent.",
   pic:require("./images/Yamaha-YZF-R1.jpg")
},


{
    name : "Honda CBR 1100XX",
    description :"This Car holds 1137cc engine in combination with powerful liquid cooled 4-cylinder ability which offers an output 153 horsepower at speed of 10,000 rpm.",
   pic:require("./images/Honda-CBR-1100XX-Blackbird.jpg")
},


{
    name : "Suzuki Hayabusa",
    description :"Suzuki Hayabusa, a heavy bike motorcycle which won the award of world fastest-heavy bike having 248 mph speeds. It works at a power of 197 hp at speed of 6750 rpm.",
   pic:require("./images/Suzuki-Hayabusa.jpg")
},
    ]
    
export function getBikesDetails(){return BikesDetails;}
    
    
    